module.exports = __webpack_public_path__ + "img/bg_tongjibg.c48b8fa3.png";